import { Component, OnInit, Output, EventEmitter, Input, OnChanges, SimpleChanges, ViewChild, ChangeDetectorRef } from '@angular/core';
// import { SortEvent } from 'primeng/components/common/api';
import { Table } from 'primeng/table';
import { SortEvent } from 'primeng/api/sortevent';
import { DomSanitizer } from '@angular/platform-browser';
import { HelperService } from 'src/app/services/utils/helper.service';
import { ExcelService } from '../../export/excel.service';
import { PdfService } from '../../export/pdf.service';
import { PrintService } from '../../export/print.service';
import { TelephonePipe } from 'src/app/pipes/telephone.pipe';
import { OverlayPanel } from 'primeng/overlaypanel';
import { Checkbox } from 'primeng/checkbox';
import { BUSY_MESSAGE, CONSTANTS } from 'src/app/dataModels/constants';
import { LazyLoadEvent } from 'primeng/api';
/**
 * Table component
 */
@Component({
  selector: 'app-ui-table',
  templateUrl: './ui-table.component.html',
  styleUrls: ['./ui-table.component.scss'],
})
export class UiTableComponent implements OnInit, OnChanges {
  /**
   * headers for the table
   */
  @Input() headers = [];

  /**
   * data for the table
   */
  @Input() data = [];

  /**
   * original data for the table
   */
  origData;

  /**
   * number of records to display per page
   */
  @Input() recordsToDisplay = 10;

  /**
   * loading indicator for the table
   */
  @Input() loading: boolean;

  /**
   * indicate if filter field has to be displayed, by default filter will be displayed
   */
  @Input() showFilter = true;

  /**
   * indicate if export button has to be displayed, by default export buttons will be displayed
   */
  @Input() showExport = true;

  /**
   * indicate if edit button has to be displayed, by default edit button will not be displayed
   */
  @Input() showEdit = false;

    /**
   * indicate if approve reject buttons has to be displayed, by default these button will not be displayed
   */
    @Input() showApproveReject = false;

  /**
   * indicate if delete button has to be displayed, by default delete button will not be displayed
   */
  @Input() showDelete = false;

  /**
   * css class list for cells or rows
   */
  @Input() cssClassList = {} as any;

  /**
   * indicate if edit, delete has to be disabled
   */
  @Input() disableTable = false;

  /**
   * caption for the table
   */
  @Input() caption;

  /**
   * empty message to be displayed where there are no records
   */
  @Input() emptyMessage = 'No data found';
  

  /**
   * html popover content
   */
  @Input() htmlPopoverContent = BUSY_MESSAGE.PLEASE_WAIT;

  /**
   * indicate if pagination has to be shown
   */
  @Input() showPagination = true;

  /**
   * option for multiselect dropdown to be displayed in table
   */
  @Input() multiSelectData = {
    data: [],
    optionLabel: 'descr',
    optionValue: 'columnValue',
  };

  /**
   * pagination row options
   */
  rowsOptions: Array<any> = [];

  /**
   * broadcast row edit event
   */
  @Output() rowEditEvent = new EventEmitter();

  /**
   * broadcast row delete event
   */
  @Output() rowDeleteEvent = new EventEmitter();

  
  /**
   * broadcast row approve event
   */
  @Output() rowApproveEvent = new EventEmitter();

  /**
   * broadcast row reject event
   */
  @Output() rowRejectEvent = new EventEmitter();

  /**
   * broadcast dynamic popover event
   */
  @Output() dynamicPopoverEvent = new EventEmitter();

  /**
   * Reference of the table component
   */
  @ViewChild(Table) table: Table;

  /**
   * sorting order
   */
  sortOrder;

  /**
   * sorting field
   */
  sortField;

  /**
   * sorted column name
   */
  sortingColumnName;

  /**
   * indicate if loading is complete
   */
  isLoadingComplete;

  /**
   * popover data
   */
  popoverdata;

  /**
   * sub header for the export
   */
  @Input() subHeader;

  /**
   * additional header for the export
   */
  @Input() additionalHeader;

  /**
   * additional data for the export
   */
  @Input() additionalData = [];

  /**
   * file name for the export
   */
  @Input() fileName;

  /**
   * indicate if all records are selected
   */
  isAllRecordsSelected: boolean;

  /**
   * list of columns to be searched globally
   */
  globalColumnsToSearch = [];

  /**
   * row being clicked
   */
  rowData: any;

  /**
   * show select check box
   */
  @Input() showSelectCheckbox = false;

  /**
   * broadcast header checked event
   */
  @Output() selectedRowsEvent = new EventEmitter();

  /**
   * reference of header checkbox
   */
  @ViewChild('headerCheckbox') headerCheckbox: Checkbox;

  /**
   * row selected
   */
  selectedRow: any;

  /**
   * indicate if table has to be scrolled
   */
  @Input() doNotScroll = false;

  /**
   * scrolling height for the container
   */
  scrollHeight = '19vw';

  /**
   * constructor to inject dependency
   * @param sanitizer instance of domsanitizer
   * @param helperService instance of helperService
   * @param excelService instance of excelService
   * @param pdfService instance of pdfService
   * @param printService instance of printService
   * @param telephonePipe instance of telephonePipe
   */
  constructor(
    private sanitizer: DomSanitizer,
    private helperService: HelperService,
    private excelService: ExcelService,
    private pdfService: PdfService,
    private printService: PrintService,
    private telephonePipe: TelephonePipe,

    private cd: ChangeDetectorRef
  ) {}

  /**
   * initialize component
   */
  ngOnInit() {
    this.rowsOptions = [10, 25, 50, 100, { showAll: 'All' }];
    if(this.headers){
    for (const header of this.headers) {
      this.globalColumnsToSearch.push(`${header.field}`);
    }
  }
  }

  /**
   * changes event, when any @Input() properties data changes
   * @param changes changes event
   */
  ngOnChanges(changes: SimpleChanges) {
    if(this.headers) {
    for (const header of this.headers) {
      if (header.sort) {
        this.sortField = header.field;
        this.sortOrder = header.sortOrder;
      }
    }
   }
    if (changes.data) {
      this.origData = Array.from(changes.data.currentValue);
      if (this.isAllRecordsSelected) {
        this.recordsToDisplay = changes.data.currentValue.length;
      }

      // this.cd.detectChanges();
      setTimeout(() => {
        this.scrollHeight = this.data.length > 10 ? '55vw' : 'null';
        this.doNotScroll = this.data.length < 10 ? false: this.doNotScroll;
      });
    }
  }

  

  /**
   * get css class for the cell
   * @param index cell index
   * @param key key
   * @param cellTemplate add class based on cellTemplate
   */
  getCssClass(index, key, cellTemplate) {
    let cssClass = '';
    if (cellTemplate) {
      switch (cellTemplate) {
        case 'RECORD_TEMP':
        case 'VIEW':
        case 'VIEWBTN':
        case 'INFO': {
          cssClass = ' justify-content-center ';
          break;
        }
        default: {
          cssClass = '';
          break;
        }
      }
    }
    if (this.cssClassList && this.cssClassList[`'${index}${key}'`]) {
      return `${cssClass} ${this.cssClassList[`'${index}${key}'`]}`;
    } else {
      return cssClass;
    }
  }

  /**
   * get column to be sorted
   * @param column column to be sorted
   */
  getSortableColumn(column) {
    if (column.noSort) {
      return column.noSort;
    } else {
      return false;
    }
  }

  /**
   * Sort the table
   * @param event sorting event
   */
  sort(event: SortEvent) {
    const field = event.field;

    let isSort = true;

    const headerToSortArr = this.headers.filter((header) => {
      return header.field === field;
    });

    const sortType = headerToSortArr[0].sortType ? headerToSortArr[0].sortType : 'string';

    if (this.sortOrder === -1 && event.order === 1 && this.sortingColumnName === field) {
      this.sortOrder = event.order;
      this.data = Array.from(this.origData);
      this.table.reset();
      isSort = false;
    }

    this.sortOrder = event.order;

    this.sortingColumnName = field;

    if (isSort) {
      event.data.sort((data1, data2) => {
        const value1 = data1[event.field];
        const value2 = data2[event.field];
        let result = null;

        if (value1 == null && value2 != null) {
          result = -1;
        } else if (value1 != null && value2 == null) {
          result = 1;
        } else if (value1 == null && value2 == null) {
          result = 0;
        } else if (sortType === 'string') {
          result = value1.localeCompare(value2);
        } else if (sortType === 'number') {
          const val1 = value1.toString().replace(/\$/g, '');
          const val2 = value2.toString().replace(/\$/g, '');
          result = +val1 < +val2 ? -1 : +val1 > +val2 ? 1 : 0;
        } else if (sortType === 'date') {
          const d1 = new Date(value1);
          const d2 = new Date(value2);
          result = d1 < d2 ? -1 : d1 > d2 ? 1 : 0;
        } else {
          result = value1 < value2 ? -1 : value1 > value2 ? 1 : 0;
        }

        return event.order * result;
      });
    }
  }

  /**
   * broadcast row edit event
   * @param row row clicked
   * @param column column clicked
   */
  handleClickEvent(row, column) {
    this.rowEditEvent.emit({ row, column });
  }

  /**
   * broadcast popover event, so that the component having the table can dynamically set the data for the table
   * @param row row where the popover has to be displayed
   */
  handleDynamicPopoverEvent(row) {
    this.isLoadingComplete = false;
    this.htmlPopoverContent = '';
    if (!row.popoverdata) {
      this.htmlPopoverContent = BUSY_MESSAGE.PLEASE_WAIT;
      this.dynamicPopoverEvent.emit({ row });
    } else {
      this.htmlPopoverContent = row.popoverdata;
    }
  }

  /**
   * broadcast row delete event
   * @param row row to be deleted
   */
  handleDeleteRowEvent(row) {
    this.rowDeleteEvent.emit({ row });
  }

  /**
   * broadcast row delete event
   * @param row row to be deleted
   */
  handleApproveRowEvent(row) {
    this.rowApproveEvent.emit({ row });
  }

  /**
   * broadcast row delete event
   * @param row row to be deleted
   */
  handleRejectRowEvent(row) {
    this.rowRejectEvent.emit({ row });
  }

  /**
   * on selecting checkbox
   * @param row row being checked or unchecked
   * @param column column clicked
   */
  pageChange(event) {
    this.cd.detectChanges();
  }

  /**
   * if cell data has newline characters, replace with html break character so that he text will appear will new line
   * @param data cell value to be sanitized for html content
   */
  sanitize(data, format) {
    if (!this.helperService.IsNullOrEmpty(data)) {
      if (format === 'PHONE') {
        return this.telephonePipe.transform(data);
      } else {
        return this.sanitizer.bypassSecurityTrustHtml(data.toString().replace(/[\n]/g, '<br/>'));
      }
    } else {
      return data;
    }
  }

  /**
   * export table to pdf
   */
  exportTableToPDF() {
    this.pdfService.exportTableToPDF(
      this.subHeader,
      this.data,
      this.headers,
      Array.from(this.additionalData) || [],
      this.additionalHeader || '',
      this.fileName
    );
  }

  /**
   * export table to xls
   */
  exportTableToXLS() {
    this.excelService.exportTableToExcel(
      this.subHeader,
      this.data,
      this.headers,
      Array.from(this.additionalData) || [],
      this.additionalHeader || '',
      this.fileName
    );
  }

  /**
   * print the table
   */
  printTable() {
    this.printService.printTableData(
      this.subHeader,
      this.data,
      this.headers,
      Array.from(this.additionalData) || [],
      this.additionalHeader || ''
    );
  }

  /**
   * display overlay panel
   * @param event event
   * @param row row being clicked
   * @param overlayPanel overlaypanel to show
   */
  showOverlay(event, row, overlayPanel: OverlayPanel) {
    this.rowData = row;
    overlayPanel.toggle(event);
  }

  /**
   * header checkbox click event
   * @param event checkbox event
   */
  handleHeaderClickEvent(event) {
    for (const row of this.data) {
      row.select = event.checked && event.checked?.length > 0 ? 'Y' : '';
    }
    this.selectedRowsEvent.emit({ data: this.data, headerChecked: event.checked });
  }

  /**
   * display dynamic html template
   * @param row row of the table
   * @param field field to be populated
   */
  handleHTMLPopoverEvent(row, field) {
    this.htmlPopoverContent = BUSY_MESSAGE.PLEASE_WAIT;
    setTimeout(() => {
      this.htmlPopoverContent = row[field];
    });
  }

  /**
   * reset table header checkbox select
   */
  resetTableHeaderCheck() {
    this.headerCheckbox.writeValue('');
    for (const item of this.data) {
      item.select = '';
    }
  }

  /**
   * check if column has to be frozen
   * @param col column name
   */
  checkIfColumnHasToBeFrozen(col) {
    return col.isFrozen || false;
  }

  /**
   * get height for the table
   */
  getScrollHeight() {
    return this.data && this.data.length >= 10 ? this.showApproveReject ?'150vh':'auto' : 'auto';
  }

  checkScrollable() {
    return false;
  }

  /**
   * on filtering the table, call change detection
   */
  filter() {
    this.cd.detectChanges();
  }
}
